import { render, staticRenderFns } from "./C-TextArea.vue?vue&type=template&id=473d41d0&scoped=true&"
import script from "./C-TextArea.vue?vue&type=script&lang=js&"
export * from "./C-TextArea.vue?vue&type=script&lang=js&"
import style0 from "./C-TextArea.vue?vue&type=style&index=0&id=473d41d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473d41d0",
  null
  
)

export default component.exports